import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import Grid from "@material-ui/core/Grid";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { makeStyles } from "@material-ui/core/styles";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

const useStyles = makeStyles((theme) => ({
	progressCircle: {
		minWidth: "65px",
		maxWidth: "65px",
	},
	centerText: {
		textAlign: "center",
	},
	progressGutter: {
		marginBottom: 3,
	},
}));

export default function StatDialog({ stats, setShowStats, name }) {
	const classes = useStyles();

	const [open, setOpen] = React.useState(true);

	const handleClose = () => {
		setOpen(false);
		setShowStats(false);
	};

	return (
		<div>
			<Dialog
				open={open}
				onClose={handleClose}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
			>
				<DialogTitle id="alert-dialog-title">
					<span>
						{name}'s Life Stats{" "}
						<span role="img" aria-label="chart emoji">
							📊
						</span>{" "}
					</span>
				</DialogTitle>
				<DialogContent className={classes.centerText}>
					<DialogContentText id="alert-dialog-description">
						<Grid
							container
							direction="column"
							justify="center"
							alignItems="center"
						>
							<Grid item className={classes.progressGutter}>
								<CircularProgressbar
									className={classes.progressCircle}
									value={stats.luck}
									text={`Luck: ${stats.luck}%`}
									styles={buildStyles({
										// Text size
										textSize: "15px",
									})}
								/>
							</Grid>
							<Grid item className={classes.progressGutter}>
								<CircularProgressbar
									className={classes.progressCircle}
									value={stats.happiness}
									text={`Happy: ${stats.happiness}%`}
									styles={buildStyles({
										// Text size
										textSize: "15px",
									})}
								/>
							</Grid>
							<Grid item className={classes.progressGutter}>
								<CircularProgressbar
									className={classes.progressCircle}
									value={stats.health}
									text={`Health: ${stats.health}%`}
									styles={buildStyles({
										// Text size
										textSize: "15px",
									})}
								/>
							</Grid>
							<Grid item className={classes.progressGutter}>
								<CircularProgressbar
									className={classes.progressCircle}
									value={stats.thinkingPower}
									text={`IQ: ${stats.thinkingPower}%`}
									styles={buildStyles({
										// Text size
										textSize: "15px",
									})}
								/>
							</Grid>
							<Grid item className={classes.progressGutter}>
								<CircularProgressbar
									className={classes.progressCircle}
									value={stats.looks}
									text={`Looks: ${stats.looks}%`}
									styles={buildStyles({
										// Text size
										textSize: "15px",
									})}
								/>
							</Grid>
						</Grid>
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleClose} color="primary">
						Cool{" "}
						<span role="img" aria-label="Thumbs up emoji">
							👍🏻
						</span>
					</Button>
				</DialogActions>
			</Dialog>
		</div>
	);
}
